import { render, staticRenderFns } from "./AlojamientosPopup.vue?vue&type=template&id=34904ab3&scoped=true"
import script from "./AlojamientosPopup.vue?vue&type=script&lang=js"
export * from "./AlojamientosPopup.vue?vue&type=script&lang=js"
import style0 from "./AlojamientosPopup.vue?vue&type=style&index=0&id=34904ab3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34904ab3",
  null
  
)

export default component.exports